import { render, staticRenderFns } from "./Item16Text.vue?vue&type=template&id=5a7e08ef&"
import script from "./Item16Text.vue?vue&type=script&lang=js&"
export * from "./Item16Text.vue?vue&type=script&lang=js&"
import style0 from "./Item16Text.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
